import { render, staticRenderFns } from "./SavedSearchesSelector.vue?vue&type=template&id=6d05dc8a&"
import script from "./SavedSearchesSelector.vue?vue&type=script&lang=js&"
export * from "./SavedSearchesSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports